import * as S from '../scss/theme';
// import styled from 'styled-components';
import React, { useEffect, useState, useRef } from 'react';
import PaginatedItems from '../page_board_comm/PaginatedItems';
import fnc from '../mymod/commFunction';


import { useSelector, useDispatch } from 'react-redux';
import { setBoardKind, setBoardTitle } from "../reduxToolkit/reduxBoard";



  const Board = () => {

    const isRefreshBoard = useSelector(state => state.reduxStoreBoard.isRefreshBoard);
    const [items, setItems] = useState(null);
    const dispatch = useDispatch();
  
    useEffect(() => {
      fncSelectList();
    }, [isRefreshBoard]);
  
    
      function fncSelectList() {   
        const stCode = fnc.getCookie('stCode');
        const kind ='board';
        fnc.sendAxios('/boardList', { stCode, kind }, (res) => {

          if (Array.isArray(res)) {
            dispatch(setBoardTitle({text:'공지사항', value: kind, textEng:'공지사항'}));
            dispatch(setBoardKind(kind));
            setItems(res);

          } else {
            console.log("속성이 obj 내에 없습니다.");
          }
        });
      }
  
     
      //-------------------------------------------------------------------------
  
      return (
        // <S.Section_full_homepage>
        <div className="Board">
         { items && <PaginatedItems items={items} itemsPerPage={5} /> }
             
        </div>
        // </S.Section_full_homepage>
      );

}

export default Board;
